export default __webpack_public_path__ + "static/media/announcer-victory.4a5845e3.mp3";